import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import {UntypedFormControl, UntypedFormGroup, ReactiveFormsModule} from "@angular/forms";
import {Subject} from "rxjs";
import { NZ_MODAL_DATA, NzModalRef, NzModalModule } from "ng-zorro-antd/modal";
import {BookingService, OperationService} from "@beautyapp/core";
import {takeUntil} from "rxjs/operators";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { NzFormModule } from "ng-zorro-antd/form";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzAlertModule } from "ng-zorro-antd/alert";
import { NzSpaceModule } from "ng-zorro-antd/space";
import { TextareaComponent } from '@beautyapp/form';
import { NzPopconfirmDirective } from 'ng-zorro-antd/popconfirm';

@Component({
    selector: 'webapp-operation-delete',
    templateUrl: './operation-delete.component.html',
    styleUrls: ['./operation-delete.component.scss'],
    standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    NzModalModule,
    NzFormModule,
    NzButtonModule,
    NzInputModule,
    NzAlertModule,
    NzSpaceModule,
    TextareaComponent,
    NzPopconfirmDirective
  ]
})
export class OperationDeleteComponent implements OnInit, OnDestroy {
  modal = inject(NzModalRef);
  private operationService = inject(OperationService);

  operationId?: number  = inject(NZ_MODAL_DATA).operationId;
  isLoading: any = false;

  form: UntypedFormGroup = new UntypedFormGroup({
    disableReason: new UntypedFormControl(null),
  });

  sub$ = new Subject();

  ngOnInit(): void {}

  deleteBooking() {
    this.isLoading = true;
    this.operationService
      .delete(this.operationId, this.form.value)
      .pipe(takeUntil(this.sub$))
      .subscribe((res) => {
        this.modal.triggerOk();
        this.isLoading = false;
      });
  }

  ngOnDestroy(): void {
    this.sub$.next(null);
    this.sub$.complete();
  }
}
